// modules/PageLoading.js
import React        from 'react';

class PageLoading extends React.Component {
	render() {
		return (
			null
		);
	}
}

export default PageLoading;


/** WEBPACK FOOTER **
 ** ./src/modules/PageLoading.js
 **/